import { useEffect } from 'react';
import { useRedirect } from '@common/hooks/useRedirect';
import { AppealStatus } from '@seek/je-shared-data/lib/types/authentication';
import { getUser } from '@store/auth';
import { useAppSelector } from '@store/hooks';
import { getLocalisation } from '@store/localisation';

export const useRedirectUserWithoutSubmittedAppealStatus = () => {
  const { countryCode } = useAppSelector(getLocalisation);
  const { currentUser } = useAppSelector(getUser);
  const { redirect } = useRedirect();

  useEffect(() => {
    if (currentUser?.appealStatus !== AppealStatus.SUBMITTED) {
      redirect(`/${countryCode}/home`)();
    }
  }, [redirect, currentUser, countryCode]);
};
